import { Component } from '@angular/core';

@Component({
  selector: 'lib-element-header',
  imports: [],
  templateUrl: './element-header.html',
  styleUrl: './element-header.css',
})
export class ElementHeader {

}
